<ng-template #steptemplate>
  <ng-content></ng-content>
</ng-template>
